<template>
  <div>
    <a-row type="flex" class="row_item">
      <a-col :span="2" style="padding-top: 15px">
        <span v-if="index >= 0">{{ index + 1 }}、信用付款</span>
        <span v-else>信用付款</span>
      </a-col>
      <a-col :span="22">
        <div :title="item.name">
          <span style="display: block; padding-left: 16px;">
            <span class="desc">系统编号：{{ item.number }}</span>
            <span class="desc">主体企业：{{ item.host_corporation }}</span>
            <span class="desc">合同类型：{{ item.sell_contract_id > 0 ? '购销合同' : '普通合同' }}</span>
            <span class="desc">购销合同编号：{{ item.sell_contract_id > 0 ? item.sell_contract_number : item.contract_number }}</span>
            <span class="desc">金额：{{ (item.amount).toFixed(4) | numberFormat }}</span>
            <span class="desc">货币：{{ dictionaries.currency[item.currency] }}</span>
            <span class="desc">人民币金额：{{ (item.amount_cny).toFixed(4) | numberFormat }}</span>
            <span class="desc">付款方式：{{ dictionaries.trade_credit_letter_payment_method[item.payment_method] }}</span>
            <span class="desc">开出时间：{{ item.pay_date }}</span>
            <span class="desc">承兑时间：{{ item.acceptance_date }}</span>
            <span class="desc">贴现时间：{{ item.discount_date }}</span>
            <span class="desc">到期时间：{{ item.due_date }}</span>
            <span class="desc">承兑金额：{{ (item.acceptance_amount).toFixed(4) | numberFormat }}</span>
            <span class="desc">已开启审批：
              <a-popconfirm
                title="确定开启审批吗?"
                :disabled="item.is_approval_needed"
                @confirm="() => approvalNeeded(item, 'trade_credit_letter', item.status === 3)">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.is_approval_needed">审批状态：<span :class="statusText[item.status < 0 ? 0 : item.status][0]">{{ item.is_approval_needed ? (dictionaries.approval_result[item.status] ? dictionaries.approval_result[item.status] : '无') : un_approval_needed_text }}</span></span>
            <span class="desc">已完成：
              <a-popconfirm
                title="确定已完成?"
                :disabled="item.is_done"
                @confirm="() => handleCreditLetterDone(item)">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_done" :disabled="item.is_done"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-action:add>已存档：
              <a-popconfirm
                title="确定存档吗?"
                :disabled="item.is_archived"
                @confirm="() => handleArchived(item, 'credit_letter')">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.create_by">创建人：{{ item.create_by }}</span>
            <span class="desc">创建时间：{{ item.create_time | dayjs }}</span>
          </span>
          <span style="padding-left: 16px;" class="desc" v-if="item.remark">备注：{{ item.remark }}</span>
          <div style="padding-left: 16px;" v-if="!item.is_archived && !item.is_done && ((item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed)) && edit">
            <span class="desc">操作:</span>
            <span class="ope">
              <span @click="handleEditRecord(item, 'credit_letter')" v-if="!item.is_approval_needed">编辑</span>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(item, 'credit_letter')">
                <span v-if="(item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed)">删除</span>
              </a-popconfirm>
              <a-popconfirm
                v-if="item.is_approval_needed && item.status === 3"
                title="确定重启审批?"
                @confirm="() => approvalNeeded(item, 'trade_credit_letter', true)">
                <span>重启审批</span>
              </a-popconfirm>
            </span>
          </div>
          <div>
            <a-collapse :bordered="false" style="padding-left: 0px;">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="2" header="附件" :style="customStyle" v-if="item.attachment.length > 0">
                <a v-for="(attachment) in item.attachment" :key="attachment.id" :href="attachment.url" target="_blank" class="desc"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
              </a-collapse-panel>
              <a-collapse-panel key="3" header="详情" :style="customStyle" v-if="item.detail.length > 0">
                <div v-for="(d) in item.detail" :key="d.id">
                  <span class="desc">系统编号：{{ d.number }}</span>
                  <span class="desc">银行：{{ d.bank }}</span>
                  <span class="desc">金额：{{ (d.amount).toFixed(2) | numberFormat }}</span>
                  <span class="desc">信用证货币到人民币的汇率：{{ d.to_cny_rate }}%</span>
                  <span class="desc">预估人民币金额：{{ (d.amount_cny).toFixed(2) | numberFormat }}</span>
                  <span class="desc" v-if="false">融资利率：{{ d.financing_rate }}%</span>
                  <span class="desc">类别：{{ d.type }}</span>
                  <span class="desc">费用：{{ (d.fee).toFixed(2) | numberFormat }}</span>
                  <span class="desc">额度占用：{{ (d.limit).toFixed(2) | numberFormat }}</span>
                  <span class="desc">开证时间：{{ d.start_date }}</span>
                  <span class="desc">已完成：
                    <a-popconfirm
                      title="确定已完成?"
                      :disabled="d.is_done || item.is_archived || item.is_done"
                      @confirm="() => handleCreditLetterDetailDone(d)">
                      <a-switch checked-children="是" un-checked-children="否" :checked="d.is_done" :disabled="d.is_done || item.is_archived || item.is_done"/>
                    </a-popconfirm>
                  </span>
                  <br><span class="desc" v-if="d.remark">备注：{{ d.remark }}</span>
                  <br><span class="desc" v-if="!d.is_done && !item.is_archived && edit">操作:</span>
                  <span class="ope">
                    <span @click="handleEditRecord(d, 'credit_letter_detail')" v-if="!d.is_done && !item.is_archived && edit">编辑</span>
                  </span>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'

export default {
  name: 'CreditLetterInfo',
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
    index: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      dictionaries: Dictionaries,
      un_approval_needed_text: '未开启审批',
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      }
    }
  },
  methods: {
    handleArchived (item, type) {
      this.$emit('handleArchived', item, type)
    },
    handleEditRecord (item, type) {
      this.$emit('handleEditRecord', item, type)
    },
    handleDelete (item, type) {
      this.$emit('handleDelete', item, type)
    },
    approvalNeeded (item, type, approval_again) {
      this.$emit('approvalNeeded', item, type, approval_again)
    },
    handleCreditLetterDetailDone (item) {
      this.$emit('handleCreditLetterDetailDone', item)
    },
    handleCreditLetterDone (item) {
      this.$emit('handleCreditLetterDone', item)
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
